// eslint-disable-next-line import/prefer-default-export
export function propsEditor() {
  return {
    // Objeto como el modelo Formula del servidor
    modelValue: { type: Object, default: () => {} },
    // Objetos VariableFormula
    variablesDisponibles: { type: Array, default: () => [] },
  };
}
